import {
  Configuration,
  PublicClientApplication,
  IPublicClientApplication,
  AccountInfo,
} from "@azure/msal-browser";
import { AccountIdentifiers } from "@azure/msal-react";

export const iffLoginRequest = {
  scopes: ["User.Read", process.env.REACT_APP_MSAL_SCOPE!],
};

const iffTokenSilentRequest = {
  scopes: [process.env.REACT_APP_MSAL_SCOPE!],
};

const configuration: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID!,
    authority: process.env.REACT_APP_MSAL_AUTHORITY_URL,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL,
  },
};

export const msalInstance = new PublicClientApplication(configuration);

export async function acquireToken(
  instance: IPublicClientApplication,
  account: AccountInfo,
) {
  const response = await instance.acquireTokenSilent({
    ...iffTokenSilentRequest,
    account,
  });
  if (response) {
    const { accessToken, expiresOn } = response;
    return {
      apiAccessToken: accessToken,
      apiAccessTokenExpiresOn: expiresOn || undefined,
    };
  }
}

// As not exported, similiar identify method of useAccount (https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/src/hooks/useAccount.ts).
export function getAccount(
  allAccounts: AccountInfo[] = [],
  accountIdentifiers: AccountIdentifiers,
): AccountInfo | null {
  if (
    allAccounts.length > 0 &&
    (accountIdentifiers.homeAccountId ||
      accountIdentifiers.localAccountId ||
      accountIdentifiers.username)
  ) {
    const matchedAccounts = allAccounts.filter(accountObj => {
      if (
        accountIdentifiers.username &&
        accountIdentifiers.username.toLowerCase() !==
          accountObj.username.toLowerCase()
      ) {
        return false;
      }
      if (
        accountIdentifiers.homeAccountId &&
        accountIdentifiers.homeAccountId.toLowerCase() !==
          accountObj.homeAccountId.toLowerCase()
      ) {
        return false;
      }
      if (
        accountIdentifiers.localAccountId &&
        accountIdentifiers.localAccountId.toLowerCase() !==
          accountObj.localAccountId.toLowerCase()
      ) {
        return false;
      }
      return true;
    });

    return matchedAccounts[0] || null;
  } else {
    return null;
  }
}
